module.exports = __webpack_public_path__ + "static/media/stop-8.018abf46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-8.svg
// module id = 1353
// module chunks = 0